import { render, staticRenderFns } from "./PageDashboard.vue?vue&type=template&id=a7bd2ad4&"
import script from "./PageDashboard.vue?vue&type=script&lang=js&"
export * from "./PageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PageDashboard.vue?vue&type=style&index=0&id=a7bd2ad4&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7bd2ad4')) {
      api.createRecord('a7bd2ad4', component.options)
    } else {
      api.reload('a7bd2ad4', component.options)
    }
    module.hot.accept("./PageDashboard.vue?vue&type=template&id=a7bd2ad4&", function () {
      api.rerender('a7bd2ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/PageDashboard.vue"
export default component.exports